import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import moment from "moment";
import { Redirect, Link } from "react-router-dom";
import Swal from "sweetalert2";
import { baseurl } from "./baseurl";
import axios from "axios";
import { GetIp } from "./views/Forms/ShortCutComponents/Get_ip";
import ResponseLoader from "./views/Forms/ShortCutComponents/ResponseLoader";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { headers, username, companyId } from "../src/utils/variables";
import ReportsCriteria from "../../react_adminAS/src/views/Forms/ShortCutComponents/ReportsCriteria";

export default function AuthorizeTeamOverview(props) {
  var token = localStorage.getItem("token");

    const [table, setTable] = useState({
    OverViewDataTable: [],
  });
  const [loadingResponse, setLoadingResponse] = useState(false);
  useEffect(() => {
    getData();
  }, []);

  const getData = (fromDate, toDate, branch_id, subMode_id, bankDesc_id) => {
    setLoadingResponse(true);
    const fDate = fromDate ? moment(fromDate).format("YYYY-MM-DD") : null;
    const tDate = toDate ? moment(toDate).format("YYYY-MM-DD") : null;
    axios
      .post(
        `${baseurl}/BCS/getBankCardSetup`,
        {
          companyId: companyId,
          username: username,
          fromDate: fDate,
          toDate: tDate,
          bankDesc_id,
          branch_id: branch_id?.id,
          subMode_id: subMode_id?.id,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        setLoadingResponse(false);
        setTable({
          OverViewDataTable: res.data.data,
        });
      })
      .catch((err) => {
        console.log(err);
        setLoadingResponse(false);
      });
  };
    // const redirectToForm = (row, type, attachment) => {
    // props.history.push({
    //   pathname: "/BankCardSetup",
    //   state: {
    //     // rowData: row,
    //     id: row?.Bank_card_id,
    //     type,
    //     // attachment,
    //   },
    // });
const redirectToForm = (row, type) => {

  const editData = {
    id: row?.Bank_card_id,
    type: type
  };

  console.log("editData>>", editData);
  localStorage.setItem("BankOverviewData", JSON.stringify(editData));

  window.open("#/BankCardSetup", "_blank");
};
  const getUserIp = async function () {
    let res = await GetIp();
    console.log(res);
    return {
      userIp: res.ip,
      userCountry: res.country,
    };
  };
  const setDelete = async (row) => {
    console.log("row>>", row);
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoadingResponse(true);
        let { userIp, userCountry } = await getUserIp();

        axios
          .post(
            `${baseurl}/BCS/deleteBankCardSetup`,
            {
              id: row?.Bank_card_id,
              username: username,
              companyId: companyId,
              userIp,
              userCountry,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then((response) => {
            setLoadingResponse(false);

            Swal.fire("Deleted!", "Your Record has been deleted.", "success");
            getData();
          })
          .catch((err) => {
            console.log(err);
            setLoadingResponse(false);
            Swal({
              title: "Failed!",
              text: "You won't be able to delete this",
              icon: "error",
              button: "Try Again!",
            });
          });
      }
    });
  };
  function orderDetHandler(cell, row) {
    console.log("aaaa", cell, row);
    return (
      <div>
        <span>
          <Button
            style={{ margin: "3px" }}
            type="submit"
            size="sm"
            // color="primary"
            onClick={() => redirectToForm(row, 1)}
          >
            <i className="fa fa-eye"></i>
          </Button>
        </span>
        <span>
          <Button
            style={{ margin: "3px" }}
            type="submit"
            size="sm"
            color="success"
            onClick={() => redirectToForm(row, 2)}
          >
            Edit
          </Button>
        </span>
        {/* <span>
          <Button
            style={{ margin: "3px" }}
            type="submit"
            size="sm"
            color="danger"
            onClick={() => setDelete(row)}
          >
            Delete
          </Button>
        </span> */}
      </div>
    );
  }

  const handleFind = (p) => {
    console.log("p",p)
    const { fromDate, toDate, branch_id, subMode_id, bankDesc_id } = p;
    getData(fromDate, toDate, branch_id, subMode_id,bankDesc_id );
  };
  const options = {
    paginationShowsTotal: true,
    page: 1,
    sizePerPage: 15,
    pageStartIndex: 1,
    paginationSize: 5,
    prePage: "Prev",
    nextPage: "Next",
    firstPage: "First",
    lastPage: "Last",
    prePageTitle: "Go to previous",
    nextPageTitle: "Go to next",
    firstPageTitle: "Go to first",
    lastPageTitle: "Go to Last",
    paginationPosition: "top",
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "All",
        value: table.OverViewDataTable?.length,
      },
    ],
  };
  return (
    <> 
        <div className="container-fluid bg-white">
          {loadingResponse && <ResponseLoader />}
          <div className="row">
            <div className="col-md-6 h3 p-3">Bank Card Setup Overview</div>
            <div className="col-md-6 d-flex flex-row-reverse mt-3">
              <Link
                to={"/BankCardSetup"}
                class="btn btn-outline-success rounded-pill mx-2 mb-3"
              >
                <i class="fa fa-plus pr-2" aria-hidden="true"></i>
                Add Bank Card Setup
              </Link>
            </div>
          </div>
          <div translate="no" className="">
            <ReportsCriteria
              // reportName="Bank Card Setup Overview"
              lovs={["branch", "subMode", "bankdesc"]}
              // status={2}
              callBack={() => {}}
              isMulti={false}
              companyId={companyId}
              token={token}
              username={username}
              handleFind={(p) => handleFind(p)}
              // for not showing link and description pass false overviewTable
              overviewTable={false}
            />
          </div>
          <div translate="no" className="">
            <BootstrapTable
              data={table.OverViewDataTable}
              striped
              pagination
              hover
              search
              tableHeaderClass="rpr_header"
              tableBodyClass="rpr_body"
              containerClass="rpr_container"
              options={options}
            >
              <TableHeaderColumn
                dataField="sub_inv_desc"
                dataAlign="center"
                width="10%"
                dataSort={true}
              >
                Branch
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="paymode_desc"
                dataAlign="center"
                width="10%"
                dataSort={true}
                isKey={true}
              >
                Pay Mode
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="Sub_Mode"
                dataAlign="center"
                width="15%"
                dataSort={true}
              >
                Sub Mode
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="card_type_desc"
                dataAlign="center"
                width="10%"
                dataSort={true}
              >
                Card Type
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="bank_desc"
                dataAlign="center"
                width="10%"
                dataSort={true}
              >
                Bank Desc
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="from_date"
                dataAlign="center"
                width="10%"
              >
                From Date
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="to_date"
                dataAlign="center"
                width="10%"
              >
                To Date
              </TableHeaderColumn>
              <TableHeaderColumn
                dataAlign="center"
                dataField="Bank_card_id"
                width="15%"
                dataFormat={orderDetHandler}
                className="rpr_header"
              >
                Action
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
        </div>
    </>
  );
}
